import { commentIncludes } from '../../constants/includes';
import { buildIncludesString } from '../../utilities/utilityFunctions';
import { BaseConnector } from './baseConnector';

class CommentConnector extends BaseConnector {
  static defaultCommentIncludes = buildIncludesString(
    commentIncludes.contents,
    commentIncludes.contentTypes,
  );

  getComments(hearingId, includes) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/comment?include=${
      includes ?? CommentConnector.defaultCommentIncludes
    }`;
    return this.authFetch(url);
  }

  getPaginatedComments(hearingId, pageIndex, pageSize, includes) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/comment?include=${
      includes ?? CommentConnector.defaultCommentIncludes
    }&PageIndex=${pageIndex}&PageSize=${pageSize}`;
    return this.authFetch(url);
  }

  // Atomic JsonApi request - create / update is same endpoint
  createComment(hearingId, comment) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/comment`;
    return this.authPost(url, comment);
  }

  // Soft delete
  updateComment(hearingId, commentId) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/comment/${commentId}`;
    return this.authPatch(url);
  }
}

export { CommentConnector };
